/*
 * @Author: wuxb wuxb@zghits.com
 * @Date: 2020-05-07 14:16:05
 * @LastEditors: smf
 * @LastEditTime: 2023-09-19 17:19:15
 * @FilePath: \carowner-admin-masterd:\zghPro\official-website-app\src\layouts\PrimaryLayout.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * Created by wxb on 2023/07/24.
 */
import React, { PureComponent, lazy, Suspense } from "react";
import DocumentTitle from 'react-document-title';
import { withRouter } from "react-router-dom";
import { Layout, Menu, Spin } from "antd";
import './PrimaryLayout.less';
import logo from './img/logo.svg';
import imgLoading from './img/imgLoading.gif';
import rotationChart from './img/rotationChart.png';
import coreProducts from './img/coreProducts.png';
import { Helmet } from 'react-helmet';
import ImageOnLoad from 'react-image-onload';
import HomePage from './components/homePage';
import AboutUs from './components/aboutUs';
import ClassicCases from './components/classicCases';
import CoreProducts from './components/coreProducts';
// 懒加载组件
// const HomePage = lazy(() => import('./components/homePage'));
// const AboutUs = lazy(() => import('./components/aboutUs'));
// const ClassicCases = lazy(() => import('./components/classicCases'));
// const CoreProducts = lazy(() => import('./components/coreProducts'));
const { Content, Header, Footer } = Layout;


class PrimaryLayout extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            screenHeight: document.documentElement.clientHeight,
            menuKey: "1",
            isLoading: true
        };
        this.carouselref = React.createRef();
    }
    componentDidMount() {
        window.onresize = () => {
            let height = document.documentElement.clientHeight;
            this.setState({ screenHight: height })
        }

        // const img = new Image();
        // img.src = rotationChart;
        // img.onload = () => {
        //     this.setState({ isLoading: false })
        // };
    }
    handleImageLoad = () => {
        console.log('图片加载完成');
        this.setState({ isLoading: false })
    }
    //监听锚点事件
    menuOnchang = ({ item, key, keyPath, selectedKeys, domEvent }) => {
        console.log(key);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        this.setState({ menuKey: key })
    }
    render() {
        const { menuKey, screenHeight, isLoading } = this.state;
        const imagePaths = [
            rotationChart,
            // '路径/到/图片2.jpg',
            // '路径/到/图片3.jpg'
        ];

        const layout = (
            <Layout>
                <Header>
                    <div className="zgh-header-card">
                        <div className="logo"><img alt='logo' style={{ marginTop: 15 }} width={32} height={32} src={logo} /></div>
                        <div className="zgh-companyName-text">智共荟智能科技</div>
                        <div className="zgh-headerMenu-Tab">
                            <Menu theme="light" mode="horizontal" onSelect={(k) => this.menuOnchang(k)} selectedKeys={[menuKey]} defaultSelectedKeys={['1']}>
                                <Menu.Item key="1">首页</Menu.Item>
                                <Menu.Item key="2">核心产品</Menu.Item>
                                <Menu.Item key="3">经典案例</Menu.Item>
                                <Menu.Item key="4">关于我们</Menu.Item>
                            </Menu>
                        </div>
                    </div>
                </Header>
                <div style={{ display: 'none' }}>
                    {imagePaths.map((path, index) => (
                        <ImageOnLoad
                            key={index}
                            src={path}
                            onLoad={this.handleImageLoad}
                        />
                    ))}
                </div>
                {
                    isLoading ?
                        <div style={{ width: '100%', height: screenHeight, display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
                            <img src={imgLoading} />
                        </div>
                        :
                        <Content>
                            {/* <Suspense fallback={<div style={{ width: '100%', height: screenHeight, display: 'flex', alignItems: 'center', justifyContent: 'center', }}><img src={imgLoading} /></div>}> */}
                            {
                                menuKey === "1" ?
                                    <HomePage dataObjectClick={this.menuOnchang} />
                                    : menuKey === "2" ?
                                        <CoreProducts dataObjectClick={this.menuOnchang} />
                                        : menuKey === "3" ?
                                            <ClassicCases />
                                            : menuKey === "4" ?
                                                <AboutUs />
                                                : <HomePage />
                            }
                            <>
                                <div className="zgh-company-aboutUs">
                                    <div className="zgh-company-aboutUs-title"><div className="zgh-company-aboutUs-uitlogo"></div>上海智共荟智能科技有限公司</div>
                                    <div className="zgh-company-aboutUs-telephone">
                                        <div className="zgh-company-aboutUs-telephoneIcon"></div>
                                        <div>
                                            <div className="zgh-company-aboutUs-telephoneNum">021-66630102</div>
                                            <div className="zgh-company-aboutUs-telephoneWeekday">工作日：9:00-17:00</div>
                                        </div>
                                    </div>
                                    <div className="zgh-company-aboutUs-address">
                                        <div className="zgh-company-aboutUs-addressIcon"></div>
                                        <div className="zgh-company-aboutUs-addressText">公司地址：上海宝山区漠河路600号东鼎国际大厦B座25楼</div>
                                    </div>
                                    <div className="zgh-company-aboutUs-videoID">
                                        <span className="zgh-company-aboutUs-videoID-describe">关注视频号</span>
                                    </div>
                                    <div className="zgh-company-aboutUs-officialAccount">
                                        <span className="zgh-company-aboutUs-officialAccount-describe">关注公众号</span>
                                    </div>
                                </div>
                                <div className="zgh-company-filings">
                                    <div className="zgh-company-filings-icon"></div>
                                    <div className="zgh-company-filings-security"><a target={"_blank"} href={"https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011302007341"}>沪公网安备31011302007341号</a></div>
                                    <div className="zgh-company-filings-icp"><a target={"_blank"} href={"https://beian.miit.gov.cn/"}>沪ICP备2023014600号</a></div>
                                </div>
                            </>
                            {/* </Suspense> */}
                        </Content>
                }

            </Layout>

        )
        return (
            <React.Fragment>
                <Helmet>
                    <title>上海智共荟智能科技有限公司</title>
                    <meta name="description" content="上海智共荟智能科技有限公司官网" />
                </Helmet>
                <DocumentTitle title='上海智共荟智能科技有限公司'>
                    <div>{layout}</div>
                </DocumentTitle>
            </React.Fragment>
        );
    }
}

export default withRouter(PrimaryLayout)
